<template>
  <div id="app" style="height:100%;overflow-y:hidden;">
      <router-view  :ifsp="device == 'sp' || device == 'tab'"/>
  </div>
</template>

<script>

export default {
  name: 'App',  
  data: function(){
    var getDevice = (function(){
    var ua = navigator.userAgent;
    if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
        return 'sp';
    }else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
        return 'tab';
    }else{
        return 'other';
    }})();
		return{
			device: getDevice,
      ifsp: getDevice == 'sp' || getDevice == 'tab',
		}
	},
  computed: {
    message(){
     return this.$store.getters.message
   }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
/* #main_pc {
  margin-bottom:0px;
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
}
#main_sp {
  margin-top: 35px;
  flex-wrap: wrap;
} */
</style>
